module.exports = __webpack_public_path__ + "static/media/no-permission.66e4e0fc.png";